export default {
  dashboard: null,
  selectedTag: null,
  expandedDeal: null,
  loading: false,
  expandedDealLoading: false,
  error: '',
  createNoteModal: {
    dealUid: null,
    isVisible: false,
  },
  notification: {
    message: null,
    type: null,
    autoClose: false,
  },
};
